// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function ArrowDown(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "ArrowDown" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.2662 16.2647L19.236 10.4974L21 12.3053L12 21L3 12.3053L4.76397 10.4974L10.7338 16.2647L10.7338 3L13.2662 3L13.2662 16.2647Z", fill: "currentColor" }))));
});
//# sourceMappingURL=ArrowDown.js.map